import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { useSendCode } from '@/hooks/useSendCode'

export default React.memo(function VerificationCode() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { sendCodeLoading, sendCode } = useSendCode()
  // 重新发送验证码
  const handleResendCode = async () => {
    await sendCode({ account: state?.account || '', scene: 'register' })
  }
  // 提交验证码
  const handleSubmit = (code: string) => {
    if (state?.account) {
      // 验证码验证成功，跳转到设置密码页面
      navigate(`/register/set-password`, {
        state: {
          account: state?.account,
          code,
        }
      })
    }
  }
  return (
    <PageLayout>
      <Header leftChildren={<Back />} centerChildren={<div className='text-3.75 font-medium text-black'>{t('验证')}</div>} />
      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-6">
        <VerificationCodeInput
          account={state?.account || ''}
          onResendCode={handleResendCode}
          onSubmit={handleSubmit}
          resendLoading={sendCodeLoading}
          submitButtonText={t('完成')}
        />
      </div>
    </PageLayout>
  )
})